@if (!isLoading) {
  <div class="main-container" data-cy="patient-portal-treatments-main-container">
    <div class="page-header" data-cy="patient-portal-treatments-header">
      Treatment Plans
    </div>
    <mat-divider data-cy="patient-portal-treatments-divider"></mat-divider>
    @if (treatmentPlans.length === 0) {
      <div class="no-invoices-message" data-cy="patient-portal-treatments-no-plans-message">
        You currently have no treatment plans
      </div>
    }
    @if (treatmentPlans.length > 0) {
      <div class="payments-container" data-cy="patient-portal-treatments-list-container">
        @for (treatmentPlan of treatmentPlans; track treatmentPlan; let i = $index) {
          <div class="payment-item" data-cy="patient-portal-treatments-plan-item" [class.offset]="i % 2">
            <div class="item-detail" data-cy="patient-portal-treatments-plan-description-label">
              {{ treatmentPlan.Description }}
            </div>
            <!--<div class="item-detail">
            {{ paymentObj.PaymentAmount | currency }}
          </div>-->
          <div class="item-detail"
            [class.paid-detail]="treatmentPlan.approved"
            [class.unpaid-detail]="!treatmentPlan.approved"
            data-cy="patient-portal-treatments-plan-status-label">
            {{ treatmentPlan.approved ? 'Approved' : 'Awaiting Approval' }}
          </div>
          <div class="item-detail">
            <button mat-button color="primary" (click)="openReportForSelectedOption(treatmentPlan)" data-cy="patient-portal-treatments-open-plan-button">Open</button>
          </div>
        </div>
      }
    </div>
  }
</div>
}
@if (isLoading) {
  <div class="spinner-container" data-cy="patient-portal-treatments-loading-spinner-container">
    <mat-spinner data-cy="patient-portal-treatments-loading-spinner"></mat-spinner>
  </div>
}
